export const translatedCustomCtaLabel = (
  englishLabel: string | null | undefined,
  frenchLabel: string | null | undefined,
  lang: string | undefined,
) => {
  // Determine if a custom label is provided
  const hasCustomLabel = !!englishLabel || !!frenchLabel;

  // Use the appropriate custom label based on the current language.
  // NOTE: if French but no French label, fall back to English label
  // This means if neither label is provided, customLabel will be undefined.
  // We will fall back to the default label below in that case.
  const customLabel = lang === 'fr' && frenchLabel ? frenchLabel : englishLabel;

  return { hasCustomLabel, customLabel };
};
